import { call, select } from 'typed-redux-saga';

import { CookieSetOptions, type CookieManager } from '../../../helpers/cookie-manager';
import { selectClientCookiesDomain } from '../selectors';

type SetCookieByConfigOptions = Omit<CookieSetOptions, 'domain'>;

export function* setCookieByConfig(
    this: CookieManager,
    name: string,
    value: string,
    options: SetCookieByConfigOptions = {}
) {
    const domain = yield* select(selectClientCookiesDomain);

    yield* call(this.set, name, value, { ...options, domain });
}
